import { IMAGES, TerminalImage } from "./TerminalImage";

export const Hero = () => (
  <header
    className="py-16 md:py-24 border-b border-line bg-gradient-to-b from-navy to-navy-panel"
    data-testid="hero-section"
  >
    <div className="max-w-6xl mx-auto px-6">
      <div
        className="inline-flex items-center gap-2 px-3 py-1 rounded bg-cy/10 border border-cy/30 text-cy text-xs font-mono mb-6"
        data-testid="hero-badge"
      >
        <span className="w-2 h-2 rounded-full bg-cy animate-pulse" />
        <span>A$234.5B AUSTRALIAN PRIVATE DEBT HUB</span>
      </div>

      <h1 className="font-display text-6xl md:text-8xl lg:text-9xl text-white uppercase leading-[0.9] tracking-tight">
        <span className="ln-3">
          <span>AUSTRALIA'S INDEPENDENT</span>
        </span>
        <span className="ln-3">
          <span className="text-cy">PRIVATE CREDIT GUIDE</span>
        </span>
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mt-10 items-end">
        <div className="lg:col-span-7 space-y-6">
          <p className="reveal-d3 text-base md:text-lg text-mut leading-relaxed" data-testid="hero-subline">
            The independent digital gateway to Australia's institutional non-bank credit market, offering
            verified manager directory data, ASIC REP 814 intelligence, and direct borrower access.
          </p>

          <div className="reveal-d3 flex flex-wrap gap-4 items-center font-mono text-xs">
            <a
              href="#terminal-enquiry"
              data-testid="hero-borrower-cta"
              className="px-6 py-3 rounded bg-cy text-navy font-bold hover:bg-cy-soft transition-colors"
            >
              BORROWER ENQUIRY
            </a>
            <a
              href="#terminal-news"
              data-testid="hero-newsletter-cta"
              className="px-6 py-3 rounded border border-line bg-surface text-white hover:border-cy/50 transition-colors"
            >
              MONTHLY BRIEF SIGN-UP
            </a>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="rounded-xl overflow-hidden border border-cy/30 shadow-2xl bg-surface p-2">
            <TerminalImage
              src={IMAGES.hero}
              alt="Financial analytics terminal telemetry"
              testId="hero-terminal-visual"
              className="aspect-[16/10] rounded-lg drift-cyan p-6"
            >
              <div className="flex justify-between items-center text-[10px] font-mono text-cy">
                <span>TERMINAL TELEMETRY</span>
                <span className="px-2 py-0.5 rounded bg-cy/20">LIVE METRIC</span>
              </div>
              <div className="bg-navy/90 p-3 rounded border border-line">
                <div className="text-[11px] font-mono text-mut">COMPOUND ANNUAL GROWTH RATE</div>
                <div className="text-2xl font-display text-white mt-0.5" data-testid="hero-cagr-metric">
                  21.0% P.A. (2015 &middot; 2025)
                </div>
              </div>
            </TerminalImage>
          </div>
        </div>
      </div>
    </div>
  </header>
);
